// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2qKw3","title":"ClientReferral_title__Ou1B1","itemText":"ClientReferral_itemText__jawxA"};